module.exports = __webpack_public_path__ + "static/media/right-bg-bs.bb4dde9b.png";